import { Navigate } from "react-router-dom";

export default function RegisterUserPage() {
  return <Navigate to="/admin/users/new" replace />;
}
